module.exports = __webpack_public_path__ + "static/img/jira-icon.d17c41d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jira-icon.png
// module id = Gj7b
// module chunks = 1